import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';
import { AuthUser } from '@/modules/auth/models/AuthUser';

export class AiRouteConfig extends RouteConfig {
  canAccessRoute(): boolean {
    const authUser: AuthUser | null = getters.auth.getUser();

    return !!authUser?.permission?.canAccessEstateRag;
  }
}
